export function SectionLabel({ children, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="h-px w-10 bg-rust" />
      <span className="label-font text-xs text-rust">{children}</span>
    </div>
  );
}

export function PageHero({ overline, title, accent, subtitle, image }) {
  return (
    <section className="relative bg-espresso text-cream overflow-hidden">
      {image && (
        <img
          src={image}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-espresso via-espresso/85 to-espresso/40" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 md:py-32">
        <SectionLabel>{overline}</SectionLabel>
        <h1 className="mt-5 uppercase text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 700, letterSpacing: "0.01em" }}>
          {title} {accent && <span className="text-rust">{accent}</span>}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-base md:text-lg text-cream/80 leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
